import { render, staticRenderFns } from "./SuspendFlyer.vue?vue&type=template&id=068632bd"
import script from "./SuspendFlyer.vue?vue&type=script&lang=js"
export * from "./SuspendFlyer.vue?vue&type=script&lang=js"
import style0 from "./SuspendFlyer.vue?vue&type=style&index=0&id=068632bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports